import { SubmitHandler, useForm } from 'react-hook-form';
import { error, information } from 'src/constants/messages';
import { tenantText } from 'src/constants/texts';
import { Tenant } from 'src/data-type/data-types';
import { tenantData } from 'src/service/tenant-data';
import FormInput from './form-input';

const TenantRegister = () => {
  const {
    register,
    handleSubmit,
    getValues,
    setValue,
    reset,
    formState: { errors },
  } = useForm<Tenant>();

  const onSubmit: SubmitHandler<Tenant> = async (rawData) => {
    const res = await tenantData.add(rawData);

    if (res === undefined) return;

    if (res.status === 200) {
      window.alert(information.successRegister);
      reset();
    } else if (res.status === 400) window.alert(error.duplicatedData);
    else {
      window.alert(error.failedRegister);
      console.log(res.data);
    }
  };

  const generatePassword = () => {
    const dakokuPassword = `${Math.random().toString(36).slice(-6)}${Math.random().toString(36).slice(-6)}`;
    const dotPass = `${Math.random().toString(36).slice(-6)}${Math.random().toString(36).slice(-6)}`;

    setValue('dakokuPassword', dakokuPassword);
    setValue('apiPassword', dotPass);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="mt-1 flex flex-col space-y-3">
        <FormInput
          text={tenantText.id}
          size={15}
          type="number"
          placeHolder="Ex:123456"
          formRegister={{
            ...register('id', {
              maxLength: { value: 8, message: error.exceeded },
              required: error.required,
              onChange: () => {
                if (getValues('id')) generatePassword();
              },
            }),
          }}
          errorMessage={errors.id?.message}
          testId="id"
        />
        <FormInput
          text={tenantText.name}
          size={70}
          formRegister={{
            ...register('name', {
              maxLength: { value: 70, message: error.exceeded },
              required: error.required,
            }),
          }}
          errorMessage={errors.name?.message}
          testId="name"
        />
        <FormInput
          text={tenantText.dakokuPassword}
          size={20}
          placeHolder={information.autoFilled}
          readOnly
          formRegister={{ ...register('dakokuPassword') }}
          testId="dakoku-password"
        />
        <FormInput
          text={tenantText.apiPassword}
          size={20}
          placeHolder={information.autoFilled}
          readOnly
          formRegister={{ ...register('apiPassword') }}
          testId="api-password"
        />
        <FormInput
          text={tenantText.expirationDate}
          type={'date'}
          formRegister={{ ...register('expirationDate') }}
          testId="expiration-date"
        />
      </div>

      <button
        className="mt-6 h-12 w-full rounded-2xl border bg-sky-200 shadow-lg"
        onSubmit={handleSubmit(onSubmit)}
        data-cy="register"
      >
        登録
      </button>
    </form>
  );
};

export default TenantRegister;
